import { render, staticRenderFns } from "./CardCompetencies.vue?vue&type=template&id=75c4c1fc&scoped=true"
import script from "./CardCompetencies.vue?vue&type=script&lang=js"
export * from "./CardCompetencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c4c1fc",
  null
  
)

export default component.exports